import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GroupMember, GroupsService } from '@rocksoft/security-sdk';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { GroupApiActions, MemberUserListActions, MemberUserResolverActions } from './member-user.actions';

@Injectable()
export class MemberUserEffects {
  private readonly groupService = inject(GroupsService);
  private readonly actions$ = inject(Actions);

  groupMemberLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberUserResolverActions.memberUsersRequested),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.getGroupUsers({ id: group.id }),
          (members: GroupMember[]) => GroupApiActions.memberUsersLoaded({ memberUsers: members }),
          (error) => GroupApiActions.memberUsersLoadedError({ error })
        )
      )
    );
  });

  groupMemberDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupApiActions.memberUsersGroupDeleted),
      mergeMap(({ memberUser }) =>
        safeMap(
          this.groupService.removeUserFromGroup({ id: memberUser.parentId ?? '', userId: memberUser.id }),
          () => MemberUserListActions.memberUsersDeleted({ memberUser }),
          (error) => GroupApiActions.memberUsersDeleteError({ error })
        )
      )
    );
  });

  groupMemberAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupApiActions.memberUsersAdded),
      mergeMap(({ group, userToAdd }) =>
        safeMap(
          this.groupService.addUserToGroup({ id: group.id, memberModel: { id: userToAdd.id } }),
          () => MemberUserListActions.memberUsersAdded({ group, userToAdd }),
          (error) => GroupApiActions.memberUsersAddedError({ error })
        )
      )
    );
  });
}
